<template>
  <IQOS systemDependency="inside" required :enabled="isActive" :title="$t('inside.geolocation.title')">
    <p class="qrw-paragraph-md iqos-comment mt-16" v-if="!isActive">
      {{ $t('inside.geolocation.off_desc') }}
    </p>
   
    <p class="comment c-grey title" v-if="editing && geolocation_mode != 'disabled'">{{$t('inside.geolocation.about')}}</p>
    <BaseTabSwitcher 
      v-model="optionalMode"
      class="w-100 mt-16"
      cssWidth="100%"
      size="lg"
      :tabs="[{
        text: $t('inside.geolocation.switcher_required'),
        value: 'general'
      }, {
        text: $t('inside.geolocation.switcher_optional'),
        value: 'optional'
      }]"
      
      v-if="isActive"/>
    
    <div v-if="geolocation_mode != 'disabled'" class="mt-16">
      <GoogleMapDisplay
        class="iqos-group-item"
        :lat="location.lat"
        :lon="location.lon"
        :radius="location.radius"
        :zones="[location]"
        :show_zones="true"
        @pin="onMapPin"
        ref="googleMap"
        v-if="loaded"
      />
      
      <BaseUnitInput 
        class="w-100 mt-16"
        fullWidth 
        type="number" 
        :unitPlaceholder="$t('units.meters')"
        @blur="onEditFinish"
        v-model.number="location.radius" :placeholder="$t('inside.geolocation.radius_ph')" :readonly="false" v-if="isActive"/>
      <p class="qrw-paragraph-md mt-16 iqos-comment" v-if="isActive">
        {{ $t('inside.geolocation.input_general')}}
      </p>
      <!-- <BaseInput class="radius-input" :value="`${location.radius} м.`" placeholder="300 м" v-if="!editing"/> -->
      <p class="comment c-grey" v-if="false">
          {{ $t('inside.geolocation.recommended_radius') }}
        </p>
    </div>

    <template #actions>
       <BaseToggleSwitcher v-model="isActive"/>
    </template>
  </IQOS>
</template>

<script>
import GoogleMapDisplay from "@/components/GoogleMapDisplay.vue";

export default {
  data() {
    return {
      geolocation_mode: "disabled",
      editing: false,
      loaded: false,
      is_active: false,
      location: {
        lat: 0,
        lon: 0,
        radius: 0
      }
    };
  },
  methods: {
    switchMode(mode) {
      if (this.editing) {
        this.geolocation_mode = mode;
      }
    },
    showEditUI() {
      this.editing = true;
    },
    hideEditUI() {
      this.resetValues();
      this.editing = false;
    },
    onMapPin(pos) {
        this.location.lat = pos.lat;
            this.location.lon = pos.lon;

        this.onEditFinish();
    },
    onEditFinish() {
        this.$store.commit('setCafeGeolocationMode', this.geolocation_mode);
        this.$store.commit('setCafeGeneralLocation', this.location);
        this.$store.dispatch('saveCafe');

        // this.editing = false;

        this.$store.dispatch('auditlog/write', {
          type: 'inside_geolocation', 
          payload: this.location
        });
    },
    geocodeAddress() {
      const geocoder = new window.google.maps.Geocoder();
      geocoder.geocode(
        {
          address: this.cafe.address
        },
        (results, status) => {
          if (status == window.google.maps.GeocoderStatus.OK) {
            const start_pos = results[0].geometry.location;

            this.location.lat = start_pos.lat();
            this.location.lon = start_pos.lng();
          }

          this.loaded = true;
        }
      );
    },
    resetValues() {
      this.geolocation_mode = this.cafe.geolocation_mode || "disabled";
      if (this.cafe.location && this.cafe.location.lat && this.cafe.location.lon) {
        this.location.lat = this.cafe.location.lat;
        this.location.lon = this.cafe.location.lon;
        this.location.radius = this.cafe.location.radius;
        this.loaded = true;
      } else {
        this.geocodeAddress();
      }
    }
  },
  computed: {
    cafe() {
      return this.$store.state.cafe;
    },
    isActive: {
      get() {
        return this.geolocation_mode != 'disabled';
      },
      set(v) {
        if (v) {
          this.geolocation_mode = 'general';
        } else {
          this.geolocation_mode = 'disabled';
        }
        
        this.onEditFinish();
      }
    },
    optionalMode: {
      get() {
        return this.geolocation_mode;
      },
      set(v) {
        this.geolocation_mode = v;
        this.onEditFinish();
      }
    }
  },
  mounted() {
    this.resetValues();
  },
  components: {
    GoogleMapDisplay,
  }
};
</script>

<style scoped>
.radius-input {
    width: 100%;
    text-align: center;
}
span {
  font-size: 2vh;
  display: block;
  padding: 1vh 0;
}

</style>